import { networkCall } from "../../../../../util/network-call/network-call";

export const AdminModuleListLoader = async () => {

    const response = await networkCall('/modules');

    return !response ? null : response;

};